


const Nav = ({ register, setRegister }) => {
    
    return <ul className='nav'>
        <li>
            <button
                className={!register ? 'current': null}
                onClick={()=>setRegister(false)}
            >
                ログイン
            </button>
        </li>
        <li>
            <button
                onClick={() => setRegister(true)}
                className={register ? 'current' : null}
            >
            新規登録
            </button>
        </li>
    </ul>
}
export default Nav
